import BaseServices from "./BaseServices";

const EmailServices = {
    GetInboundEmailByPage: async (page) => {
        return BaseServices.Post("/api/Email/get-inbound-email", page);
    },
    UpdateArchiveInboundEmail: async (id, status) => {
        return BaseServices.Get(`/api/Email/update-archive-inbound-email/${id}/${status}`);
    },
    GetInboundEmailById: async (id) => {
        return BaseServices.Get(`/api/Email/get-inbound-email-by-id/${id}`);
    },
};

export default EmailServices;
